import React from 'react';
import BaseDashboardLayout from './BaseDashboardLayout';
import { navItems } from '../components/sidebar/items/dashboardItems';

const LTKUserDashboard = ({ children, width }) => {
	return <BaseDashboardLayout children={children} width={width} navItems={navItems} />;
};

export default LTKUserDashboard;
